/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartialParentRole
 */
export interface PartialParentRole {
    /**
     * 
     * @type {number}
     * @memberof PartialParentRole
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialParentRole
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the PartialParentRole interface.
 */
export function instanceOfPartialParentRole(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartialParentRoleFromJSON(json: any): PartialParentRole {
    return PartialParentRoleFromJSONTyped(json, false);
}

export function PartialParentRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialParentRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function PartialParentRoleToJSON(value?: PartialParentRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'enabled': value.enabled,
    };
}

